import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import ScrollManager from "@/components/ScrollManager";
import LandingPage from "@/pages/LandingPage";
import LeOrigini from "@/pages/LeOrigini";
import LaTostatura from "@/pages/LaTostatura";
import LeMiscele from "@/pages/LeMiscele";
import ZioCamillo from "@/pages/ZioCamillo";
import CaffeColaNelMondo from "@/pages/CaffeColaNelMondo";
import CaffeColaNelTempo from "@/pages/CaffeColaNelTempo";
import OnTheRoad from "@/pages/OnTheRoad";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import CookieBanner from "@/components/CookieBanner";
import LangRoute from "@/components/LangRoute";
import useSyncHtmlLang from "@/hooks/useSyncHtmlLang";

function AppInner() {
  // Reusable page routes (mounted under each language prefix)
  const pageRoutes = (
    <>
      <Route index element={<LandingPage />} />
      <Route path="le-origini" element={<LeOrigini />} />
      <Route path="la-tostatura" element={<LaTostatura />} />
      <Route path="le-miscele" element={<LeMiscele />} />
      <Route path="zio-camillo" element={<ZioCamillo />} />
      <Route path="nel-mondo" element={<CaffeColaNelMondo />} />
      <Route path="nel-tempo" element={<CaffeColaNelTempo />} />
      <Route path="on-the-road" element={<OnTheRoad />} />
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
      <Route path="cookie-policy" element={<CookiePolicy />} />
    </>
  );

  return (
    <BrowserRouter>
      <RouterInner pageRoutes={pageRoutes} />
    </BrowserRouter>
  );
}

function RouterInner({ pageRoutes }) {
  useSyncHtmlLang();
  return (
    <>
      <ScrollManager />
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            background: "#3b2417",
            color: "#f5ead6",
            border: "1px solid #c5371f",
          },
        }}
      />
      <Routes>
        {/* Italian (default, no prefix) */}
        <Route path="/" element={<LangRoute lang="it" />}>{pageRoutes}</Route>
        {/* English */}
        <Route path="/en" element={<LangRoute lang="en" />}>{pageRoutes}</Route>
        {/* Japanese */}
        <Route path="/ja" element={<LangRoute lang="ja" />}>{pageRoutes}</Route>
      </Routes>
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <AppInner />
      </div>
    </HelmetProvider>
  );
}

export default App;
